{
  "commonHeader": {
    "upgradeToPro": "업그레이드",
    "learnMore": "자세히 알아보기",
    "AIProductivitySuite": {
      "title": "AI 생산성 제품군",
      "desc": "영감을 주는 논의를 인상적인 결과물로 전환하세요."
    },
    "aicForAdmin": {
      "coachMark": {
        "title": "AI로 조직 계정 관리",
        "description": "계정 관련 질문에 대한 지능형 답변과 설정 탐색 도움을 받으세요.",
        "terms": "Zoom의 베타 기능을 사용하면 {0}에 동의하는 것입니다",
        "termsText": "Zoom 베타 프로그램 약관"
      },
      "diveDeeper": "자세히 살펴보기",
      "shareFeedback": "{0}에서 피드백 공유",
      "askAiAdmin": "#Ask AI admin",
      "placeholder": "조직 계정에 대해 질문하기",
      "heroInvite": "내 계정에 새 사용자를 초대하려면 어떻게 하나요?",
      "heroGroups": "사용자를 그룹에 할당하려면 어떻게 하나요?",
      "heroRoles": "역할 및 권한을 관리하는 방법을 알려 주세요"
    },
    "backMainAccount": "기본 계정으로 돌아가기",
    "discoverProducts": "제품 살펴보기",
    "pricing": "요금",
    "more": "더 보기",
    "sidebarExpanded": "펼침",
    "sidebarCollapsed": "접힘",
    "search": "검색",
    "users": "사용자",
    "settings": "계정 설정",
    "navigation": "탐색",
    "clear": "지우기",
    "searchPlaceholderAll": "사용자, 계정 설정 또는 탐색 검색",
    "searchPlaceholderUsers": "사용자 또는 탐색 검색",
    "searchPlaceholderSettings": "계정 설정 또는 탐색 검색",
    "searchPlaceholderNav": "탐색 검색",
    "searchGuide": "검색을 시작하려면 키워드를 입력하세요",
    "installOnDesktop": "데스크톱에 설치",
    "downloadCenter": "다운로드 센터",
    "getInTouch": "문의하기",
    "featuredProduct": "추천 제품",
    "logo": {
      "adminCenter": "관리 센터",
      "subAccount": "하위 계정 관리 중",
      "externalAccount": "위임된 계정 관리 중"
    }
  },
  "divisionTips": {
    "common": {
      "learnMore": "자세히 알아보기",
      "gotIt": "알겠습니다"
    },
    "coachMark": {
      "dvsTipsTitle": "이제 디비전을 사용할 수 있습니다",
      "dvsTipsContent": "디비전을 사용하면 계정 내에서 특정 Zoom 제품의 여러 인스턴스를 만들 수 있습니다."
    }
  },
  "externalAccountTips": {
    "common": {
      "learnMore": "자세히 알아보기",
      "gotIt": "알겠습니다"
    },
    "coachMark": {
      "extAccountTipsTitle": "외부 계정 관리",
      "extAccountTipsContent": "다른 계정을 관리해야 하나요? 요청만 보내세요. 상대방이 승인하면 바로 관리할 수 있습니다!"
    }
  },
  "feedback": {
    "dialogTitle": "피드백 보내기",
    "itemLableForProductArea": "제품 영역",
    "itemLableForSatisfied": "귀하의 경험에 얼마나 만족하십니까?",
    "dissatisfied": "매우 불만족",
    "satisfied": "매우 만족",
    "itemLableForFeedback": "피드백",
    "placeholder": "귀하의 아이디어, 의견, 제안에 감사드립니다.",
    "btnCancel": "취소",
    "btnSubmit": "제출",
    "supportTips": "기술 지원은",
    "btnSupport": "지원.",
    "messages": {
      "success": "피드백을 주셔서 감사합니다!",
      "productFailed": "제품 영역은 필수입니다.",
      "scoreFailed": "만족도 점수는 필수입니다."
    },
    "products": {
      "General": "일반",
      "AI": "AI",
      "Apps": "앱",
      "Calendar": "캘린더",
      "Clips": "Clips",
      "ContactCenter": "컨택 센터",
      "Docs": "문서",
      "Huddles": "Huddles",
      "Mail": "메일",
      "Meetings": "미팅",
      "Notes": "노트",
      "Phone": "Phone",
      "Revenue": "Revenue",
      "Rooms": "Rooms",
      "Scheduler": "스케줄러",
      "Tasks": "작업",
      "TeamChat": "팀 채팅",
      "WebinarsAndEvents": "웨비나 및 이벤트",
      "Whiteboard": "화이트보드",
      "WorkflowAutomations": "워크플로 자동화",
      "WorkspaceReservation": "워크스페이스 예약",
      "Workvivo": "Workvivo"
    }
  },
  "loginDisclaimer": {
    "disclaimer": "이 고지 사항은 귀하의 계정 관리자가 생성했습니다.",
    "cancel": "취소",
    "agree": "동의"
  },
  "shared": {
    "sideMenu": {
      "personal": "개인",
      "admin": "관리자",
      "menu": "메뉴",
      "pinned": "고정됨",
      "pin": "고정",
      "unpin": "고정 해제",
      "moveItem": "항목 이동",
      "myAccount": "내 계정",
      "upgradeToPro": "Pro로 업그레이드",
      "grabbedKeyboard": "{0}을(를) 잡았습니다. 위아래 화살표 키로 이동하고 스페이스 또는 Enter로 놓습니다.",
      "dropped": "{0}을(를) 놓았습니다.",
      "releasedUnchanged": "{0}을(를) 놓았으며 위치가 변경되지 않았습니다.",
      "movedToPosition": "{0}이(가) {2}개 중 {1}번 위치로 이동했습니다.",
      "movedUp": "{0}이(가) 위로 이동했습니다. 현재 위치는 {2}개 중 {1}번입니다.",
      "movedDown": "{0}이(가) 아래로 이동했습니다. 현재 위치는 {2}개 중 {1}번입니다.",
      "movedUpNew": "{0}이(가) 위로 이동했습니다. 새 위치는 {2}개 중 {1}번입니다",
      "movedDownNew": "{0}이(가) 아래로 이동했습니다. 새 위치는 {2}개 중 {1}번입니다",
      "cannotMoveFurther": "{0}을(를) 더 이상 이동할 수 없습니다.",
      "grabbedMouse": "{0}을(를) 잡았습니다. 마우스를 움직여 위치를 바꾼 뒤 클릭하여 놓고 Esc로 취소합니다."
    },
    "item": "항목",
    "gotIt": "확인",
    "adminCenterGuide": {
      "title": "Welcome to the new Admin Center",
      "content": "<p class=\"mgb-xs\">A streamlined hub to stay informed and in control.</p><p>Admin Center brings key updates, tasks, and tools together so you can configure products, track requests, and act on what matters most.</p>"
    }
  },
  "sign": {
    "signin_phone_bound_success": "전화번호 추가에 성공했습니다! 이제 향후 로그인 및 계정 복구에 사용할 수 있습니다.",
    "mfa_to_signin_phone_success": "{phone}은(는) 이제 {email}의 로그인 번호입니다.",
    "login_passkey_bound_success": "패스키가 성공적으로 생성되었습니다"
  },
  "userDifference": {
    "titleMap": {
      "licensed_collaboration": "다음 고급 관리 기능은 라이선스 사용자와 협업 사용자에게만 적용됩니다",
      "licensed_basic": "다음 고급 관리 기능은 사용 허가된 사용자 및 기본 사용자에게만 적용됩니다",
      "licensed": "다음 고급 관리 기능은 사용 허가된 사용자에게만 적용됩니다"
    },
    "support": "- 계정 설정 및 사용자 그룹 설정에서 지원됨",
    "archive_product": {
      "title": "회의 및 웨비나 보관",
      "detail": "- 계정의 사용자가 참가할 때 회의가 보관됩니다. 이 설정을 사용하려면 Zoom App Marketplace에서 <a href=\"https://marketplace.zoom.us/apps?category=archiving\" target=\"_blank\">보관 앱</a>을 설치하세요."
    },
    "restrict": {
      "title": "사용자가 회의에 참가할 때 선택한 기능 사용 제한",
      "detail": "- 선택한 기능은 회의 호스트가 회의에 사용하도록 설정한 경우에도 사용할 수 없습니다."
    },
    "meeting_integration": {
      "title": "회의 중 채팅 DLP(Data Loss Prevention) 통합 활성화",
      "detail": "- DLP를 사용 설정하면 참가자가 보내는 공개 및 비공개 채팅 메시지 모두에 DLP가 적용됩니다. 회의의 참가자(내부/외부)가 채팅 중이고 메시지가 호스트 조직의 규정 준수 정책을 위반하는 경우 메시지가 즉시 삭제됩니다."
    },
    "chat_tool": {
      "title": "채팅 에티켓 도구",
      "detail": "- 공유 콘텐츠에서 정의된 키워드 및 텍스트 패턴을 식별하고 사용자가 원치 않는 메시지를 공유하지 못하도록 방지"
    },
    "information_barriers": {
      "title": "정보 보호 기능",
      "detail": "- 정보 보호 기능은 규정 준수를 위해 특정 사용자 간의 통신을 제어합니다. 회의 및 채팅에 대한 제한은 두 그룹의 사용자와 특정 사용자가 특정 기능(예: 회의 중 채팅, 화면 공유 및 파일 전송)을 사용할 수 없도록 설정할 수 있습니다. 이러한 제한은 권한이 없는 사용자 간에 기밀 정보가 교환되는 것을 방지할 수 있습니다."
    },
    "dashboard": {
      "title": "대시보드",
      "detail": "- 회의 > 지난 회의 대시보드의 경우, 일부 사용자의 경우 3개월 동안의 데이터만 표시됩니다"
    },
    "reports": {
      "title": "보고서",
      "detail": "- 일부 사용자 보고서에는 일부 사용자의 경우 3개월 동안의 데이터만 표시됩니다: 고지 사항 보고서, 참석자 로그 보고서, 관리자 활동 로그 보고서 및 로그인/로그아웃 보고서"
    },
    "close": "닫기"
  },
  "webinarBar": {
    "body": {
      "cancel": {
        "active": {
          "webinars": {
            "admin": "{planName}이(가) {cancelDate}에 취소됩니다. 해당 날짜 이전에 웨비나 라이선스를 다시 활성화할 수 있습니다. {supportStartDate} ~ {supportEndDate} 기간 동안 고객 지원에 문의하여 기존 웨비나 데이터를 받을 수 있습니다. {dataLossDate} 이후에는 모든 웨비나 데이터가 손실됩니다.",
            "nonAdmin": "{planName}이(가) {cancelDate}에 취소됩니다. 해당 날짜까지 계정 관리자에게 문의하여 웨비나 라이선스를 다시 활성화할 수 있습니다. {supportStartDate} ~ {supportEndDate} 기간 동안 고객 지원에 문의하여 기존 웨비나 데이터를 받을 수 있습니다. {dataLossDate} 이후에는 계정의 모든 웨비나 데이터가 손실됩니다."
          },
          "admin": "{planName}이(가) {cancelDate}에 취소됩니다. 해당 날짜까지 웨비나 라이선스를 다시 활성화할 수 있습니다. {supportStartDate} ~ {supportEndDate} 기간에 고객 지원에 문의하여 기존 웨비나의 {supportContent}을(를) 받을 수 있습니다. {dataLossDate} 이후에는 계정의 모든 웨비나 데이터가 손실됩니다.",
          "nonAdmin": "{planName}이(가) {cancelDate}에 취소됩니다. 해당 날짜까지 계정 관리자에게 문의하여 웨비나 라이선스를 다시 활성화할 수 있습니다. {supportStartDate} ~ {supportEndDate} 기간에 고객 지원에 문의하여 기존 웨비나의 {supportContent}을(를) 받을 수 있습니다. {dataLossDate} 이후에는 계정의 모든 웨비나 데이터가 손실됩니다."
        },
        "expired": {
          "admin": "{planName}이(가) 취소되었습니다. {supportStartDate} ~ {supportEndDate} 동안 고객 지원에 문의하여 기존 웨비나의 {supportContent}을(를) 받거나 Zoom Webinars를 다시 구매하여 데이터 접근을 복원할 수 있습니다. {dataLossDate} 이후에는 계정의 모든 웨비나 데이터가 손실됩니다.",
          "nonAdmin": "{planName}이(가) 취소되었습니다. {supportStartDate} ~ {supportEndDate} 기간 동안 고객 지원에 문의하여 기존 웨비나의 {supportContent}을(를) 받거나, 계정 관리자에게 문의하여 Zoom Webinars를 다시 구매하고 데이터 접근을 복원할 수 있습니다. {dataLossDate} 이후에는 계정의 모든 웨비나 데이터가 손실됩니다."
        }
      },
      "paused": {
        "scheduled": {
          "webinars": {
            "admin": "{planName}이(가) {pausedDate}에 {pauseDuration} 동안 일시 중지됩니다. 일시 중지 기간 동안에는 기존 웨비나와 해당 자산만 볼 수 있습니다. 언제든지 일시 중지를 해제하고 웨비나 라이선스 구독을 다시 시작할 수 있습니다.",
            "nonAdmin": "{planName}이(가) {pausedDate}에 {pauseDuration} 동안 일시 중지됩니다. 일시 중지 기간 동안에는 기존 웨비나와 해당 자산만 볼 수 있습니다. 계정 관리자에게 문의하여 언제든지 일시 중지를 해제하고 웨비나 라이선스 구독을 다시 시작할 수 있습니다."
          },
          "admin": "{planName}이(가) {pausedDate}에 {pauseDuration} 동안 일시 중지됩니다. 일시 중지 기간 동안에는 {supportContent}만 볼 수 있습니다. 언제든지 일시 중지를 해제하고 웨비나 라이선스 구독을 다시 시작할 수 있습니다.",
          "nonAdmin": "{planName}이(가) {pausedDate}에 {pauseDuration} 동안 일시 중지됩니다. 일시 중지 기간 동안에는 {supportContent}만 볼 수 있습니다. 계정 관리자에게 문의하여 언제든지 일시 중지를 해제하고 웨비나 라이선스 구독을 다시 시작할 수 있습니다."
        },
        "active": {
          "webinars": {
            "admin": "{planName}이(가) {pausedDate}부터 시작하여 {pauseDuration} 동안 일시 중지되었습니다. 일시 중지 동안에는 기존 웨비나만 볼 수 있습니다. 언제든지 웨비나 라이선스 구독을 다시 시작할 수 있습니다.",
            "nonAdmin": "{planName}이(가) {pausedDate}부터 시작하여 {pauseDuration} 동안 일시 중지되었습니다. 일시 중지 동안에는 기존 웨비나만 볼 수 있습니다. 언제든지 계정 관리자에게 문의하여 웨비나 라이선스 구독을 다시 시작할 수 있습니다."
          },
          "admin": "{planName}이(가) {pauseDuration} 동안 일시 중지되었습니다. 일시 중지 동안에는 기존 웨비나의 {supportContent}만 볼 수 있습니다. 언제든지 웨비나 라이선스 구독을 다시 시작할 수 있습니다.",
          "nonAdmin": "{planName}이(가) {pauseDuration} 동안 일시 중지되었습니다. 일시 중지 동안에는 기존 웨비나의 {supportContent}만 볼 수 있습니다. 언제든지 계정 관리자에게 문의하여 웨비나 라이선스 구독을 다시 시작할 수 있습니다."
        }
      },
      "multiLicense": {
        "paused": {
          "scheduled": {
            "admin": "{planName} 라이선스가 {pausedDate}에 {pauseDuration} 동안 일시 중지됩니다. 웨비나를 계속 주최하려면 일시 중지가 적용되기 전에 이 사용자에게 활성 라이선스를 할당하세요. 일시 중지를 해제하여 이 라이선스를 계속 사용할 수도 있습니다.",
            "nonAdmin": "{planName} 라이선스가 {pausedDate}에 {pauseDuration} 동안 일시 중지됩니다. 일시 중지 기간 동안에는 기존 웨비나와 해당 자산만 볼 수 있습니다. 웨비나를 계속 주최하려면 일시 중지가 적용되기 전에 계정 관리자에게 문의하여 계정에 활성 라이선스를 할당하세요."
          },
          "active": {
            "admin": "{planName} 라이선스가 {pausedDate}부터 시작하여 {pauseDuration} 동안 일시 중지되었습니다. 일시 중지 동안에는 기존 웨비나만 볼 수 있습니다. 언제든지 라이선스 구독을 다시 시작하거나 계정에 활성 라이선스를 할당하여 웨비나를 계속 주최할 수 있습니다.",
            "nonAdmin": "{planName} 라이선스가 {pausedDate}부터 시작하여 {pauseDuration} 동안 일시 중지되었습니다. 일시 중지 동안에는 기존 웨비나만 볼 수 있습니다. 일시 중지 동안 웨비나를 주최하려면 계정 관리자에게 문의하여 계정에 활성 라이선스를 할당하세요."
          }
        },
        "cancel": {
          "active": {
            "admin": "{planName} 라이선스가 {cancelDate}에 취소됩니다. 웨비나 호스팅을 계속하려면 취소가 적용되기 전에 웨비나 라이선스를 다시 활성화하거나 활성 라이선스를 할당하세요. 조치를 취하지 않으면 {supportStartDate} ~ {supportEndDate}의 유예 기간 동안 고객 지원에 문의하여 기존 웨비나 데이터를 받을 수 있습니다. {dataLossDate} 이후에는 계정과 연결된 모든 웨비나 데이터가 영구적으로 삭제됩니다.",
            "nonAdmin": "{planName} 라이선스가 {cancelDate}에 취소됩니다. 웨비나 호스팅을 계속하려면 취소가 적용되기 전에 계정 관리자에게 문의하여 웨비나 라이선스를 다시 활성화하거나 활성 라이선스를 할당해 달라고 요청하세요. 조치를 취하지 않으면 {supportStartDate} ~ {supportEndDate}의 유예 기간 동안 고객 지원에 문의하여 기존 웨비나 데이터를 받을 수 있습니다. {dataLossDate} 이후에는 계정과 연결된 모든 웨비나 데이터가 영구적으로 삭제됩니다."
          },
          "expired": {
            "admin": "{planName} 라이선스가 취소되었습니다. 웨비나를 계속 주최하려면 이 사용자에게 활성 라이선스를 할당하세요. {supportStartDate}\\\\~{supportEndDate} 동안 고객 지원에 문의하여 기존 웨비나 데이터를 검색할 수 있습니다.",
            "nonAdmin": "{planName} 라이선스가 취소되었습니다. 웨비나를 계속 주최하려면 계정 관리자에게 문의하여 프로필에 활성 라이선스를 할당하세요. {supportStartDate}\\\\~{supportEndDate} 동안 고객 지원에 문의하여 기존 웨비나 데이터를 검색할 수 있습니다."
          }
        },
        "nonWebinars": {
          "paused": {
            "scheduled": {
              "admin": "{planName} 라이선스가 {pausedDate}에 {pauseDuration} 동안 일시 중지됩니다. 일시 중지 기간 동안에는 이전 웨비나의 {supportContent}만 볼 수 있습니다. 웨비나 자산에 계속 접근하려면 일시 중지가 적용되기 전에 이 사용자에게 활성 라이선스를 할당하세요. 일시 중지를 해제하여 이 라이선스를 계속 사용할 수도 있습니다.",
              "nonAdmin": "{planName} 라이선스가 {pausedDate}에 {pauseDuration} 동안 일시 중지됩니다. 일시 중지 기간 동안에는 {supportContent}만 볼 수 있습니다. 웨비나 자산에 계속 접근하려면 계정 관리자에게 문의하여 프로필에 활성 라이선스를 할당하세요."
            },
            "active": {
              "admin": "{planName}이(가) {pausedDate}부터 시작하여 {pauseDuration} 동안 일시 중지되었습니다. 일시 중지 동안에는 기존 웨비나의 {supportContent}만 볼 수 있습니다. 웨비나 자산에 계속 접근하려면 계정에 활성 라이선스를 할당하세요. 또한 언제든지 이 라이선스 구독을 다시 시작할 수 있습니다.",
              "nonAdmin": "{planName}이(가) {pausedDate}부터 시작하여 {pauseDuration} 동안 일시 중지되었습니다. 일시 중지 동안에는 기존 웨비나의 {supportContent}만 볼 수 있습니다. 일시 중지 동안 웨비나를 주최하려면 계정 관리자에게 문의하여 계정에 활성 라이선스를 할당하세요."
            }
          },
          "cancel": {
            "active": {
              "admin": "{planName}이(가) {cancelDate}에 취소됩니다. 웨비나를 계속 주최하려면 취소가 적용되기 전에 계정에 활성 라이선스를 할당하세요. {cancelDate} 이전에 이 라이선스를 다시 활성화할 수 있습니다. {supportStartDate}~{supportEndDate} 동안 고객 지원에 문의하여 기존 웨비나의 {supportContent}을(를) 검색할 수 있습니다.",
              "nonAdmin": "{planName} 라이선스가 {cancelDate}에 취소됩니다. 웨비나 호스팅을 계속하려면 취소가 적용되기 전에 계정 관리자에게 문의하여 웨비나 라이선스를 다시 활성화하거나 활성 라이선스를 할당해 달라고 요청하세요. 조치를 취하지 않으면 {supportStartDate} ~ {supportEndDate}의 유예 기간 동안 고객 지원에 문의하여 기존 웨비나의 {supportContent}을(를) 받을 수 있습니다. {dataLossDate} 이후에는 계정과 연결된 모든 웨비나 데이터가 영구적으로 삭제됩니다."
            },
            "expired": {
              "admin": "{planName} 라이선스가 취소되었습니다. 웨비나를 계속 주최하려면 이 사용자에게 활성 라이선스를 할당하세요. {supportStartDate}\\\\~{supportEndDate} 동안 고객 지원에 문의하여 기존 웨비나의 {supportContent}을(를) 검색할 수 있습니다.",
              "nonAdmin": "{planName} 라이선스가 취소되었습니다. 웨비나를 계속 주최하려면 계정 관리자에게 문의하여 프로필에 활성 라이선스를 할당하세요. {supportStartDate}\\~{supportEndDate} 동안 고객 지원에 문의하여 기존 웨비나의 {supportContent}을(를) 검색할 수 있습니다."
            }
          }
        }
      }
    },
    "supportContent": {
      "cancel": {
        "webinars": "데이터",
        "recordingsAndTranscripts": "녹음 및 대화 내용",
        "reports": "보고서",
        "summaries": "요약",
        "dashboard": "대시보드"
      },
      "paused": {
        "scheduled": {
          "recordingsAndTranscripts": "이전 웨비나의 녹화 및 대화 내용",
          "reports": "이전 웨비나 보고서",
          "summaries": "이전 웨비나 요약",
          "dashboard": "이전 웨비나 대시보드",
          "webinars": ""
        }
      }
    },
    "reactivatePlan": "요금제 다시 활성화",
    "purchasePlan": "요금제 구매",
    "removePause": "일시 중지 해제",
    "resumeSubscription": "구독 다시 시작",
    "month": "개월",
    "months": "개월",
    "assignLicense": "라이선스 할당"
  },
  "zccRenameTips": {
    "common": {
      "gotIt": "알겠습니다"
    },
    "coachMark": {
      "tipsTitle": "주소록이 고객 디렉터리로 변경됩니다",
      "tipsContent": "2026년 10월 릴리스에서 용도를 더 잘 반영하기 위해 주소록을 고객 디렉터리로 명칭을 변경합니다. 기존 기능, 권한, 워크플로는 모두 동일하게 유지되며, 지금과 같이 고객 목록(주소록)과 연락처를 계속 관리할 수 있습니다."
    }
  },
  "zoomPrivacy": {
    "agreeMain": "약관 및 정책은 업데이트 중입니다.",
    "agreeSub": "Zoom을 계속해서 사용하면 업데이트된 <a href=\"https://www.zoom.us/terms\" target=\"_blank\">서비스 약관</a> 및 <a href=\"https://www.zoom.us/privacy\" target=\"_blank\">개인정보 처리방침</a>을 수락하게 됩니다.",
    "continue": "계속"
  },
  "adminMenu": {
    "adminMenu": {
      "backMainAccount": "기본 계정으로 돌아가기",
      "backLinkedAccount": "연결된 계정으로 돌아가기",
      "backMyAccount": "내 계정으로 돌아가기",
      "myAccount": "내 계정"
    }
  },
  "aicGuide": {
    "onboarding": {
      "title": "이제 계정에서 Custom AI Companion을 사용할 수 있습니다",
      "desc": "계정에서 사용할 수 있는 Custom AI Companion 기능은 다음과 같습니다.",
      "studioTitle": "AI Studio",
      "studioDesc": "조직에 맞게 AI Companion 환경을 사용자 지정하세요.",
      "integrationsTitle": "타사 통합",
      "integrationsDesc": "타사 앱을 활용하여 워크플로를 간소화하세요.",
      "clipsTitle": "Zoom Clips용 사용자 지정 아바타",
      "clipsDesc": "사용자가 클립에서 사용할 AI 아바타를 개인화할 수 있도록 허용합니다."
    },
    "coachMark": {
      "licenseTitle": "할당할 Custom AI Companion 라이선스가 {0}개 있습니다",
      "licenseDesc": "<b>사용자 관리</b>에서 이러한 라이선스를 할당하면 사용자가 고급 AI Companion 기능을 사용하기 시작할 수 있습니다.",
      "settingTitle": "계정의 Custom AI Companion 설정 확인",
      "settingDesc": "<b>계정 설정</b>에서 각 Custom AI 기능의 설정을 구성하세요. <a href=\"/account/setting?tab=aicompanion\">설정으로 이동</a>",
      "groupSettingTitle": "그룹의 Custom AI 설정 확인",
      "groupSettingDesc": "<b>그룹 설정</b>에서 각 Custom AI 기능의 설정을 구성하세요. <a href=\"/account/group\">설정으로 이동</a>"
    },
    "common": {
      "learnMore": "자세히 알아보기",
      "quickTour": "빠른 둘러보기",
      "remindLater": "나중에 알림",
      "dismiss": "닫기",
      "next": "다음",
      "back": "뒤로",
      "gotIt": "알겠습니다",
      "goToSetting": "설정으로 이동"
    },
    "aiPanelToast": "<b>Zoom Workplace의 AI 패널</b> 설정을 켜면 Custom AI Companion의 모든 기능을 사용하기 시작할 수 있습니다."
  },
  "coachMark": {
    "coachMark": {
      "gotIt": "알겠습니다",
      "next": "다음",
      "remindMeLater": "나중에 알림",
      "waffleMenuTitle": "새로운 Zoom 웹 환경에 오신 것을 환영합니다",
      "waffleMenuDesc": "새로운 <b>제품 메뉴</b>로 어디서나 Zoom 제품에 액세스하세요.",
      "profileMenuTitle": "내 계정",
      "profileMenuDesc": "<b>내 계정</b>에서 프로필과 개인 설정을 찾으세요.",
      "personalTitle": "필요한 모든 것에 액세스",
      "personalDesc": "<b>내 계정</b>에는 프로필, 설정, 회의 대화 내용 등이 포함됩니다.",
      "adminCenterTitle": "관리 센터에서 조직 설정 찾기",
      "adminCenterDesc": "새로운 <b>관리 센터</b>에서 조직 전체의 제품을 구성하고 설정을 조정할 수 있습니다.",
      "adminMenuForTitle": "관리 센터를 능숙하게 사용하기",
      "adminMenuForAccountSettings": "<b>설정</b>에서 조직의 모든 사용자에 대한 기본 제품 설정에 액세스할 수 있습니다.",
      "adminMenuForContentManagementItem": "<b>콘텐츠 관리</b>에서 사용자가 생성한 모든 콘텐츠를 관리할 수 있습니다.",
      "adminMenuForConfigureProductsItem": "<b>제품 구성</b>에서 제품에 대한 설정 및 관리자 작업을 완료할 수 있습니다.",
      "adminMenuForNoItems": "새로운 관리 센터를 사용하면 계정 설정과 제품에 더 쉽게 액세스하고 관리할 수 있습니다. 자주 사용하는 항목을 고정하여 더 빠르게 액세스할 수도 있습니다.",
      "tryNewExperience": "새 환경 사용해 보기",
      "tryNewExperienceDetail": "한번 사용해 보세요! 언제든지 이 클래식 환경으로 돌아갈 수 있습니다.",
      "tryNewExperienceTitle": "Zoom 웹의 새로운 디자인!"
    }
  },
  "footerCopyright": {
    "copyright": "Copyright {'@'}{0} Zoom Communications, Inc. All rights reserved.",
    "terms": "약관",
    "privacy": "개인정보 처리방침",
    "trust_center": "트러스트 센터",
    "acceptable_use_guidelines": "이용 가이드라인",
    "legal": "법률",
    "do_not_sell_my_personal_information": "개인정보 선택",
    "cookie_preferences": "쿠키 환경설정",
    "pricing": "요금제 및 가격",
    "feedback": "피드백",
    "contact_us": "문의하기"
  },
  "termChange": {
    "changeTerm": {
      "title": "갱신 기간 변경 약정",
      "quoteNumbers": "수정된 주문서 - {0}",
      "content1": "본 약관에 동의함으로써 고객은 Zoom Communications, Inc.(“Zoom”)와 고객 간의 모든 주문서에 대한 기존 구독 갱신 기간을 월 단위 갱신 기간에서 {0}(으)로 변경하는 데 동의합니다. 이 약정에 대한 대가로 Zoom은 첫 번째 새 갱신 기간 동안 고객의 현재 요금을 유지하는 데 동의합니다.",
      "content2": "고객은 아래 “수락”을 클릭하면 새로운 갱신 기간 {0}이(가) 적용되며, 해당 새 갱신 기간이 고객의 현재 월 단위 갱신 기간이 종료된 다음 날부터 시작됨을 이해합니다. 이 새 갱신 기간은 현재 Zoom과 유효한 모든 주문서에 적용되며, 해당 주문서에 따른 향후 모든 갱신 기간도 동일한 기간 길이를 갖습니다.",
      "content3": "고객은 변경되는 사항이 갱신 기간뿐이며, 현재 Zoom과 유효한 각 주문서의 다른 모든 조건은 변경되지 않고 해당 조건에 따라 계속 완전한 효력을 유지함을 인정합니다.",
      "content4": "또한 이것이 고객과 Zoom 간의 계약상 약정임에 동의합니다.",
      "agreementText": "“수락”을 클릭하면 고객을 대신하여 이 변경을 수행할 권한이 있으며, 고객이 위에 명시된 조건에 동의함을 확인하는 것입니다.",
      "IDecline": "거부",
      "IAccept": "수락"
    },
    "unableToChangeTerm": {
      "title": "갱신 기간을 변경할 수 없음",
      "content": "계정은 갱신 기간을 업데이트할 자격이 없습니다. 오류인 경우 <a target=\"_blank\" href=\"{0}\">문의하기</a>.",
      "acceptedTitle": "갱신 기간이 연장됨",
      "acceptedContent": "이전에 갱신 조건을 수락했습니다. 추가 조치는 필요하지 않습니다.",
      "GotIt": "알겠습니다"
    },
    "termLengthUpdated": "갱신 기간 길이가 {0}개월로 업데이트되었습니다.",
    "termLengthUnchanged": "기간 길이가 변경되지 않았습니다.",
    "errorInfo": "서버 오류가 발생했습니다. 다시 시도하세요.",
    "x12MonthTerm": "12개월 기간",
    "x24MonthTerm": "24개월 기간",
    "x12MonthTermPlural": "12개월",
    "x24MonthTermPlural": "24개월"
  },
  "commonNoticeBars": {
    "adminReminder": {
      "content": "계정이 {0}에 <a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\">새로운 Zoom 웹 환경</a>으로 업데이트될 예정입니다.",
      "action": "<a href=\"/account/setting?tab=general#newZoomWebExperienceMigrationTimeline\" style=\"line-height: 20px;\">업데이트 시기 검토</a>"
    },
    "completed": {
      "content": "새로운 Zoom 웹 환경이 계정의 모든 사용자에게 활성화되었습니다. 사용자는 다음 로그인 시 업데이트된 인터페이스를 보게 됩니다."
    }
  }
}
